<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16GGQic/CoverDesign.jpg?1685327487456" alt="This image is the cover for the book Striking Sparks, Dreamspun Desires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Striking Sparks, Dreamspun Desires
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The Walker Boys</i></b></p><p>The stakes are high and the heat is on.</p> <p>Beau Walker, owner of the Barbecue Shack, needs the help of Jake Parnell, his one-time rival and secret crush, in a televised barbecue competition. Beau is a proud man, but the stakes are high, and smart, sexy Jake is his only hope, even if being around Jake reawakens the attraction he’s fought for years.</p> <p>Jake left his hometown, determined to build a life somewhere his sexuality wouldn’t hurt his family’s restaurant business—and far away from hunky, obstinate Beau Walker. Then his twin, Josh, is killed, and Jake returns to support his brother’s wife and children. Despite his reservations, he agrees to go head-to-head against Beau on national television. Between stress and grief, as well as pride and determination, only one thing is certain—the heat between Beau and Jake extends well beyond the kitchen.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ari McKay
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71cb4580